import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../configure';
import { IStockIndex } from '@/src/common/types';
import { CHART_PERIOD } from '@/src/common/enum';

interface IStockMarketTodayStoreData {
  isloading?: boolean;
  indices?: IStockIndex[];
  indicesPeriodFilterSelected: CHART_PERIOD;
}

const initialState: IStockMarketTodayStoreData = {
  indicesPeriodFilterSelected: CHART_PERIOD.ONE_YEAR,
};

export const smtSlice = createSlice({
  name: 'smt',
  initialState,
  reducers: {
    updateSmtData: (state, data) => {
      state.indices = data.payload.indices;
    },
    updateIndicesPeriodFilter: (state, data) => {
      state.indicesPeriodFilterSelected = data.payload.value;
    },
  },
});

export const { updateSmtData, updateIndicesPeriodFilter } = smtSlice.actions;

export const selectSmtData = (state: RootState) => state.smt;

export default smtSlice.reducer;
